import { useEffect, useRef, useState } from 'react';
import * as Sentry from '@sentry/react';
import { SentryErrorFallback } from './sentry-error-fallback';

type RouterErrorFallbackProps = {
  error: Error;
  reset: () => void;
};

export function RouterErrorFallback({ error, reset }: RouterErrorFallbackProps) {
  const [eventId, setEventId] = useState<string | undefined>();
  const capturedRef = useRef<Error | null>(null);

  useEffect(() => {
    if (capturedRef.current === error) {
      return;
    }
    capturedRef.current = error;
    setEventId(undefined);
    const capturedEventId = Sentry.captureException(error);
    if (typeof capturedEventId === 'string') {
      setEventId(capturedEventId);
    }
  }, [error]);

  return <SentryErrorFallback error={error} resetError={reset} eventId={eventId} />;
}

